import React from 'react';
import { TextField, ReferenceField, useRecordContext } from 'react-admin';

import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import NumberCurrencyField from '../common/fields/NumberCurrencyField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import ExportPDFButton from './InvoiceActionsButtons/ExportPDFButton';
import SendInvoiceButton from './InvoiceActionsButtons/SendInvoiceButton';
import ReverseInvoiceButton from './InvoiceActionsButtons/ReverseInvoiceButton';
import CloneInvoiceButton from './InvoiceActionsButtons/CloneInvoiceButton';
import PaidInvoiceButton from './InvoiceActionsButtons/PaidInvoiceButton';
import StatusField from './fields/StatusField';
import InvoiceTypeField from './fields/InvoiceTypeField';
import PeppolStatusField from './fields/PeppolStatusField';


const CustomRecordSplitButton = (props) => {
    const record = useRecordContext();

    return (
        <RecordSplitButton record={record} {...props} hasEdit={record?.status === 'draft'} hasDelete={record?.status === 'draft'}>
            <ExportPDFButton record={record} />
            <SendInvoiceButton record={record} />
            <ReverseInvoiceButton record={record} />
            <CloneInvoiceButton record={record} />
            <PaidInvoiceButton record={record} />
        </RecordSplitButton>
    );
};

const InvoiceRow = props => (
    <Datagrid rowClick="edit" {...props}>
        <InvoiceTypeField source="invoice_type" />
        <TextField source="number" />
        <ReferenceField label="Customer" source="customer_id" reference="customers" linkType="show" allowEmpty>
            <TextField source="name" />
        </ReferenceField>
        <DateField source="invoiced_at" />
        <NumberCurrencyField source="total_untaxed" label="Total excl. VAT" />
        <NumberCurrencyField source="total" label="Total incl. VAT" />
        <StatusField source="status" />
        <PeppolStatusField source="peppol_status" />
        <CustomRecordSplitButton />
    </Datagrid>
);

export default InvoiceRow;